/* @ngInject */
const myWagonSearch = (
  labels,
  utils,
  $$wagon,
  toaster,
  $$autocomplete,
) => {
  return {
    restrict: 'E',
    scope: {
      mySearchedWagons: '=?',
      myWagonSearchdata: '=?',
      restrictSearch: '=?',
      enableId: '=?',
      enableOwner: '=?',
      enableRailway: '=?',
      enableTrain: '=?',
      enableWagon: '=?',
      enableCardPanel: '=?',
      maxSize: '=?',
    },
    template: require('./myWagonSearch.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.displayOptions = false
      $scope.reRender = true
      $scope.fieldsOptions = $$wagon.metadata.fields

      $scope.searchWagonsRaw = async (_wagon, _restrictSearch) => {
        let searchdata = utils.mergeObject(_wagon, _restrictSearch)
        searchdata = $$wagon.format.server(searchdata)
        let result
        try {
          result = await $$wagon.request.getBySearch(searchdata)
        } catch (error) {
          toaster.error(error)
        }
        return result
      }

      $scope.searchWagons = async (_wagon, _restrictSearch) => {
        const response = await $scope.searchWagonsRaw(_wagon, _restrictSearch)
        try {
          const wagonsSize = utils.sizeof(response.wagons)
          if ($scope.maxSize && wagonsSize > $scope.maxSize) {
            if (toaster.confirm(labels.ask.warningSize(wagonsSize))) {
              $scope.mySearchedWagons = response.wagons
              toaster.warning(response.message)
            } else {
              toaster.warning(`Affichage annulé : ${wagonsSize} wagons`)
            }
          } else {
            $scope.mySearchedWagons = response.wagons
            toaster.message(response.message, response.color)
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.addWagonsFromSearch = async (_wagon, _restrictSearch) => {
        const response = await $scope.searchWagonsRaw(_wagon, _restrictSearch)
        try {
          const wagonsSize = utils.sizeof(response.wagons)
          if ($scope.maxSize && wagonsSize > $scope.maxSize) {
            if (toaster.confirm(labels.ask.warningSize(wagonsSize))) {
              $scope.mySearchedWagons = $scope.mySearchedWagons.concat(response.wagons)
                .filter((wagon, index, self) =>
                  index === self.findIndex((w) => (
                    w.id === wagon.id
                  ))
                )
              toaster.warning(response.message)
            } else {
              toaster.warning(`Ajout de wagon annulé : ${wagonsSize} wagons`)
            }
          } else {
            $scope.mySearchedWagons = $scope.mySearchedWagons.concat(response.wagons)
              .filter((wagon, index, self) =>
                index === self.findIndex((w) => (
                  w.id === wagon.id
                ))
              )
            toaster.message(response.message, response.color)
          }
        } catch (error) {
          toaster.error(error)
        }
      }

      $scope.removeWagonsFromSearch = async (_wagon, _restrictSearch) => {
        const wagons = await $scope.searchWagonsRaw(_wagon, _restrictSearch)

        $scope.mySearchedWagons = $scope.mySearchedWagons
          .filter((wagon) =>
            !wagons.find((w) => (
              w.id === wagon.id
            ))
          )
      }

      $scope.reinitForm = () => {
        if (toaster.confirm(labels.ask.reinitSearch)) {
          $scope.mySearchedWagons.splice(0, $scope.mySearchedWagons.length)
          $scope.myWagonSearchdata = $$wagon.new.search()
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {
        scope.mySearchedWagons = scope.mySearchedWagons || []
        scope.myWagonSearchdata = scope.myWagonSearchdata || {}
        scope.restrictSearch = scope.restrictSearch || {}
      },
      post: async (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myWagonSearch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonSearch.js